import type { HighlightedRaffleDetails } from '@/types/models/HighlightedRaffleDetails';

type MainPrize = NonNullable<HighlightedRaffleDetails['mainPrizes']>[0];

export const sortPrizesByValue = (prizes: MainPrize[]): MainPrize[] => {
  const sortedPrizes = [...prizes].sort((a, b) => {
    const indexA = a.index ?? 0;
    const indexB = b.index ?? 0;
    return indexB - indexA;
  });
  return sortedPrizes;
};
